import React from "react";
import _ from '../../../../../shared/utils/ObjectUtils';
import { config } from "../../../../../config";
import DirectValueWidget from "./DirectValueWidget";
import PropTypes from "prop-types";
import DateTimeUtils from "../../../../../shared/utils/DateTimeUtils";
import { interfaceDataTypes } from "../../../../../interfaces/utils/InterfaceUtils";

class DirectValueWidgetContainer extends React.Component {

    render() {
        let {
            id = '',
            widgetHasError = false,
            configs = {},
            value = '- - -',
            timestamp = null,
            interfaceDetails = {},
            isEditMode = false,
            isDashboardFullScreen = false,
            onRefreshClicked = () => {},
            onForceUpdateClick = () => {},
            onEditClick = () => {},
            onDuplicateClicked = () => {},
            onDeleteClicked = () => {}
        } = this.props;

        let percentage = null;
        let interfaceDataType = configs.type;
        let unitTypeSymbol = !_.isNil(interfaceDetails.unitType) && !_.isNil(interfaceDetails.unitType.properties) ? interfaceDetails.unitType.properties.symbol : "";
        let colors = widgetColors(value, null, interfaceDataType);

        const dateTime = DateTimeUtils.getDateTimeFromUnix(timestamp);

        return (
            <DirectValueWidget
                widgetHasError={widgetHasError}
                widgetId={id}
                widgetDisplayName={configs.widgetDisplayName}
                interfaceName={interfaceDetails.name}
                value={value}
                dateTime={dateTime}
                percentageValue={percentage}
                unitTypeSymbol={unitTypeSymbol}
                fontColor={colors.fontColor}
                backgroundColor={colors.backgroundColor}
                isEditMode={isEditMode}
                isDashboardFullScreen={isDashboardFullScreen}
                onForceUpdateClick={onForceUpdateClick}
                onRefreshClicked={onRefreshClicked}
                onEditClick={onEditClick}
                onDuplicateClicked={onDuplicateClicked}
                onDeleteClicked={onDeleteClicked}
            />
        );
    }
}

function widgetColors(actualValue, widgetConfig, interfaceDataType) {
    let colors = {
        fontColor: config.widgets.directValue.defaultFontColor,
        backgroundColor: config.widgets.directValue.defaultBackgroundColor
    };

    if (_.isNil(widgetConfig)) return colors;

    if(interfaceDataType !== interfaceDataTypes.INTEGER && interfaceDataType !== interfaceDataTypes.DECIMAL) {
        widgetConfig.forEach(function (config) {
            if(!_.isNil(config) && (config.value).toLowerCase() === (actualValue).toLowerCase()) {
                colors = ({
                    fontColor: config.fontColor,
                    backgroundColor: config.backgroundColor
                });
            }
        });
        return colors;
    } else {
        widgetConfig.forEach(function (config) {
            if(!_.isNil(config) && Number(config.value) <= Number(actualValue)) {
                colors = ({
                    fontColor: config.fontColor,
                    backgroundColor: config.backgroundColor
                });
            }
        });
        return colors;
    }
}

DirectValueWidgetContainer.propTypes = {
    widgetHasError: PropTypes.bool,
    configs: PropTypes.object,
    value: PropTypes.any,
    timestamp: PropTypes.number,
    interfaceDetails: PropTypes.object,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onRefreshClicked: PropTypes.func,
    onForceUpdateClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func
};

export default DirectValueWidgetContainer;